/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentResumeSubscriptionInput = {|
  corpoRef: string,
  setupIntentId?: ?string,
  paymentType?: ?string,
|};
export type PaymentCorpoResumeMutationVariables = {|
  input: PaymentResumeSubscriptionInput
|};
export type PaymentCorpoResumeMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoResumeMutation = {|
  variables: PaymentCorpoResumeMutationVariables,
  response: PaymentCorpoResumeMutationResponse,
|};
*/


/*
mutation PaymentCorpoResumeMutation(
  $input: PaymentResumeSubscriptionInput!
) {
  payment {
    corpo {
      res: resumeSubscription(input: $input) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "resumeSubscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoResumeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoResumeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed40eba86f5904cbeef343d9ff2afcb8",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoResumeMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoResumeMutation(\n  $input: PaymentResumeSubscriptionInput!\n) {\n  payment {\n    corpo {\n      res: resumeSubscription(input: $input) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2e98bc0c17c5d27451c400b3049a5f46';

module.exports = node;
